import React, { Component } from 'react';
import ResetPassword from './ResetPassword';

class Setttings extends Component {
	_handleInputChange(e) {
    this.props.onChange(e);
  }
	render() {
        return(
			<div className="panel">
                <h2>Indstillinger</h2>
                <div className="flexbox">
    				{!this.props.organization.id && <div style={{marginTop: '1em', marginBottom: '1em', marginRight: '3em'}}>
                        <label className="radiobtn">
                            <input
                                type="radio"
                                value="community"
                                name="type"
                                style={{marginRight: '1em'}}
                                onChange={(e) => this._handleInputChange(e)}
                                checked={this.props.organization.type === "community"}
                            />
                            Trossamfund
                        </label>
                        <label className="radiobtn">
                            <input
                                type="radio"
                                value="congregation"
                                name="type"
                                style={{marginRight: '1em'}}
                                onChange={(e) => this._handleInputChange(e)}
                                checked={this.props.organization.type === "congregation"}
                            />
                            Menighed
                        </label>
                    </div>}
                    <div style={{marginTop: '1em'}}>
                        <span style={{color: '#15a6b2', marginRight: '1em', fontWeight: 'bold'}}>Med i feed: </span>
                        <label className="radiobtn">
                            <input
                                type="radio"
                                value="1"
                                name="is_public"
                                style={{marginRight: '1em'}}
                                onChange={(e) => this._handleInputChange(e)}
                                checked={parseInt(this.props.organization.is_public) === 1}
                            />
                            Ja
                        </label>
                        <label className="radiobtn">
                            <input
                                type="radio"
                                value="0"
                                name="is_public"
                                style={{marginRight: '1em'}}
                                onChange={(e) => this._handleInputChange(e)}
                                checked={parseInt(this.props.organization.is_public) === 0} />
                            Nej
                        </label>
                    </div>
                </div>
                <div className="flexbox"style={{marginTop: '1.5em'}}>
                    {this.props.organization.id>0 && <div style={{marginRight: '8.25em'}}><ResetPassword organizationId={this.props.organization.id} showResetPassword={this.props.showResetPassword}  /></div>}
                    <div style={{marginTop: '1em', marginBottom: '1em'}}>
                        <span style={{color: '#15a6b2', marginRight: '1em'}}>Kategori:</span>
                        <select name="category_id" onChange={(e) => { if (window.confirm('Er du sikker på at du vil ændre kategori?')) this._handleInputChange(e)}} value={this.props.organization.category_id}>
                            <option value="">Vælg kategori</option>
                            <option value="1">Buddhistiske</option>
                            <option value="2">Hinduistiske</option>
                            <option value="3">Islamiske</option>
                            <option value="4">Jødiske</option>
                            <option value="5">Kristne</option>
                            <option value="6">Øvrige</option>
                        </select>
                    </div>
                </div>
            </div>
      	);
	}
}

export default Setttings;

 


// WEBPACK FOOTER //
// ./src/modules/admin/organization/sections/Settings.js